import {
    open,
    openUrl,
    closeAll,
    confirm,
    message,
    alert,
    notification,
} from './mg-modal';

export {
    message,
    confirm,
    alert,
    notification,
};

export const modal = {
    open,
    openUrl,
    closeAll,
    confirm,
    message,
    alert,
    notification,
};

